import "./App.css";
import { Routes, Route } from "react-router-dom";

// Pages
import Home from "./Home";
import About from "./About";
import Industries from "./Industries";
import Partners from "./Partners";
import Tenders from "./Tenders";
import Contact from "./Contact";

// Blog
import BlogSection from "./Blog"; // ⚠️ file name must be Blog.js

// Services
import Services from "./services";
import DefenceProcurement from "./services/DefenceProcurement";
import GlobalSourcing from "./services/GlobalSourcing";
import SupplyChain from "./services/SupplyChain";
import QualityAssurance from "./services/QualityAssurance";

// Layout
import Footer from "./components/footer";
import Meta from "./components/Meta";
// import Header from "./components/Header";



function App() {
  return (
    <div className="App">


      {/* <Header /> */}
      <Meta />
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* Main Pages */}
        <Route path="/about" element={<About />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/blog" element={<BlogSection />} />
        <Route path="/contact" element={<Contact />} />

        {/* Services */}
        <Route path="/services" element={<Services />} />
        <Route
          path="/services/defence-procurement"
          element={<DefenceProcurement />}
        />
        <Route
          path="/services/global-sourcing"
          element={<GlobalSourcing />}
        />
        <Route
          path="/services/supply-chain"
          element={<SupplyChain />}
        />
        <Route
          path="/services/quality-assurance"
          element={<QualityAssurance />}
        />
      </Routes>

      {/* Footer on all pages */}
      <Footer />
    </div>
  );
}

export default App;
